import PoliciesTable from './PoliciesTable';

export default PoliciesTable;
